
<div class="container-allactivity margin-left-right margin-allactivity shadow-border">
    <div class="bar-new-activity d-flex align-items-center pl-3 shadow-border">
        Modify Campaign Details
    </div>
    <div class="div-newactivity tablecontain-allactivity margin-left-right">
        <table class="table border1" matSort (matSortChange) = "sortListItems($event)">
            <thead>
                <tr class="text-light ">         
                    <th class="text-center" mat-sort-header = "badge">Name</th>  
                    <th class="text-center" mat-sort-header = "badge">Showroom</th> 
                    <th class="text-center" mat-sort-header = "country">Type</th>  
                    <th class="pl-2 text-center">Size</th>
                    <th class="pl-2 text-center">Cost</th>
                    <th class="text-center" mat-sort-header = "badge">Start Date</th>
                    <th class="text-center" mat-sort-header = "type">End Date</th>
                    <th class="text-center" mat-sort-header = "name">Image</th>
                    <th class="pl-4 th-sort-center"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of sortedList">
                    <td><div class="">{{data.name}}</div></td>
                    <td><div class="">{{data.showroom}}</div></td>
                    <td><div class="">{{data.type}}</div></td>
                    <td><div class="">{{data.size}}</div></td>
                    <td><div class="">{{data.cost| currency:'INR'}}</div></td>
                    <td><div class="">{{data.startdate}}</div></td>
                    <td><div class="">{{data.enddate}}</div></td>
                    <td>
                        <div class="d-flex media align-items-center justify-content-center">
                                <img alt="" src={{data.banner}}  class="banner-allactivity"  [ngbTooltip]="tipContent">
                        </div>
                    </td>
                    <td class="text-center">
                        <input id="checkFollower" type="checkbox" [(ngModel)]="data.checked">
                    </td>
                </tr>
            </tbody>
            </table>
    </div>
    <div class="mt-1 sl-pagination text-center justify-content-center d-flex">
        <ngb-pagination  [(page)]="page"  [maxSize]="5"
        [pageSize]="pageSize"
        [collectionSize]="sortedList.length" aria-label="Default pagination" class="pagination pagination-rounded-flat pagination-success"></ngb-pagination>
    </div>
</div> 
